export class SftpConnectionData {
  host: string;
  port: string;
  userName: string;
  password: string;
  remotePath: string;

  /**
   * Creates a new instance of SftpConnectionData from a string.
   *
   * @param input stringified SftpConnectionData.
   */
  static newFromString(input: string): SftpConnectionData {
    try {
      const rawConfig = JSON.parse(input);
      const sftp = new SftpConnectionData();
      sftp.host = rawConfig.host;
      sftp.remotePath = rawConfig.remotePath;
      sftp.port = String(rawConfig.port);
      sftp.userName = rawConfig.userName;
      sftp.password = rawConfig.password;

      return sftp;
    } catch (error) {
      return null;
    }
  }
}
